import script from "./VolumeStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./VolumeStatus.vue?vue&type=script&setup=true&lang=js"

import "./VolumeStatus.vue?vue&type=style&index=0&id=1f787087&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f787087"]])

export default __exports__